import styled from 'styled-components';

export const ExtraChargesLists = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1.2rem;
    > li{
        font-size: 1.4rem;
        line-height: 1.8rem;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
`;